<template>
	<div class="positioning-category-banner" :class="{ 'positioning-category-banner--collapsible': collapsible }" :role="collapsible ? 'button' : undefined" :tabindex="collapsible ? 0 : undefined" :aria-expanded="collapsible ? expanded : undefined" @click="onToggle" @keydown.enter.prevent="onToggle" @keydown.space.prevent="onToggle">
		<span class="positioning-category-banner__icon">
			<v-icon size="20">category</v-icon>
		</span>
		<span class="positioning-category-banner__label">{{ label }}</span>
		<v-chip size="small" variant="outlined" class="positioning-category-banner__count" readonly>{{ industrialCount }} {{ t('Industrials') }}</v-chip>
		<v-icon v-if="collapsible" class="positioning-category-banner__chevron">{{ expanded ? 'expand_less' : 'expand_more' }}</v-icon>
	</div>
</template>

<script setup>
import { useTranslator } from '@/composables/useTranslator';

const props = defineProps({
	label: { type: String, default: '' },
	industrialCount: { type: Number, default: 0 },
	collapsible: { type: Boolean, default: false },
	expanded: { type: Boolean, default: true },
});
const emit = defineEmits(['toggle']);

const t = useTranslator();

function onToggle() {
	if (props.collapsible) emit('toggle');
}
</script>

<style scoped lang="scss">
@use '@/styles/variables' as *;

.positioning-category-banner {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 12px 16px;
	background: rgba(var(--v-theme-on-surface), 0.05);
	border-left: 4px solid rgba(var(--v-theme-on-surface), 0.3);
	border-bottom: thin solid rgba(var(--v-border-color), var(--v-border-opacity));

	&--collapsible {
		cursor: pointer;
		user-select: none;
	}

	&__icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex: none;
		width: 36px;
		height: 36px;
		border-radius: 50%;
		background: rgb(var(--v-theme-surface));
		border: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
		color: rgba(var(--v-theme-on-surface), 0.7);
	}

	&__label {
		flex: 1 1 auto;
		min-width: 0;
		font-size: $font-size-large;
		font-weight: 700;
		color: $color-primary;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	&__count {
		flex: none;
		font-weight: 600;
		background: rgb(var(--v-theme-surface));
	}

	&__chevron {
		flex: none;
		color: rgba(var(--v-theme-on-surface), 0.6);
	}
}
</style>
